import { Box, Stack, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";
import { blueberryTwilightPaletteLight } from "@mui/x-charts/colorPalettes";

const CHART_SIZE = 200;

export default function TicketPieChart({ title, data }) {
  const totalCount =
    data?.reduce((acc, curr) => acc + (Number(curr?.count) || 0), 0) ?? 0;

  const transformedData = data
    ? data.map((item, index) => {
        const titleText = item["reservation.title"] ?? "";
        const pct =
          totalCount > 0
            ? ((Number(item?.count) || 0) / totalCount) * 100
            : 0;
        return {
          id: index,
          value: Number(item?.count) || 0,
          label: `${pct.toFixed(2)}% ${titleText}`.trim(),
        };
      })
    : [];

  const palette = blueberryTwilightPaletteLight;

  return (
    <Box
      sx={{
        boxShadow: "0px 4px 18px rgba(216, 216, 216, 0.6)",
        width: "100%",
      }}
    >
      <Box sx={{ bgcolor: "#FAFAFA", p: "0.5em 1em", borderRadius: "5px" }}>
        <Typography variant="subtitle1" sx={{ color: "#081531" }}>
          {title}
        </Typography>
      </Box>
      <Box
        sx={{
          bgcolor: "#FFF",
          p: "1em",
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "stretch", sm: "flex-start" },
          gap: 2,
          minHeight: "150px",
        }}
      >
        <Box
          sx={{
            flexShrink: 0,
            width: CHART_SIZE,
            height: CHART_SIZE,
            alignSelf: { xs: "center", sm: "flex-start" },
          }}
        >
          <PieChart
            width={CHART_SIZE}
            height={CHART_SIZE}
            margin={{ top: 4, right: 4, bottom: 4, left: 4 }}
            colors={palette}
            series={[
              {
                data: transformedData,
                highlightScope: { faded: "global", highlighted: "item" },
                faded: {
                  innerRadius: 20,
                  additionalRadius: -10,
                  color: "gray",
                },
                innerRadius: 40,
                outerRadius: 80,
                paddingAngle: 2,
                cornerRadius: 4,
              },
            ]}
            legend={{ hidden: true }}
          />
        </Box>

        <Stack
          spacing={1.25}
          sx={{
            flex: 1,
            minWidth: 0,
            justifyContent: "center",
            py: { xs: 0, sm: 0.5 },
          }}
        >
          {transformedData.map((item, index) => (
            <Box
              key={item.id}
              sx={{
                display: "flex",
                alignItems: "flex-start",
                gap: 1.25,
              }}
            >
              <Box
                sx={{
                  width: 14,
                  height: 14,
                  borderRadius: "4px",
                  bgcolor: palette[index % palette.length],
                  flexShrink: 0,
                  mt: "3px",
                }}
              />
              <Typography
                variant="body2"
                sx={{
                  color: "#081531",
                  lineHeight: 1.45,
                  wordBreak: "break-word",
                  overflowWrap: "anywhere",
                }}
              >
                {item.label}
              </Typography>
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
